import React, { useEffect, useRef, useState } from "react";
import { Box, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import colors from "../../shared/themes/colors";
import useTranslation from "../../shared/hooks/useTranslation";
import LanguageMenuItem from "../../shared/components/LanguageMenuItem";
import MenuButton from "../../public/components/shared/MenuButton";
import accountContext from "../../account/accountContext";
import { dt } from "../../shared/themes/redesignTokens";

const AccountMobileMenu = () => {
  const { translate: tAccount } = useTranslation("account");
  const { translate: tLayout } = useTranslation("layout");

  const navigate = useNavigate();

  const [open, setOpen] = useState<boolean>(false);
  const { pathname } = useLocation();
  const user = accountContext.user;

  const handleMenuOpen = () => {
    setOpen(!open);
  };

  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (open) containerRef.current?.focus();
  }, [open]);

  const createNavHandler =
    (path: string, state?: Record<string, unknown>) => () => {
      setOpen(false);
      navigate(path, state ? { state } : undefined);
    };

  return (
    <>
      <MenuButton menuOpen={open} onClick={handleMenuOpen} />

      <Box
        ref={containerRef}
        tabIndex={-1}
        onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
        className="w-full"
        sx={{
          position: "absolute",
          top: 80,
          zIndex: 1000,
          bottom: 0,
          right: 0,
          height: "min-content",
          background: colors.primary.white1,
          display: open ? "block" : "none",
          borderRadius: "0px 0px 8px 8px",
          boxShadow: "0 32px 32px 0 rgba(0, 33, 89, 0.098)",
        }}
      >
        <LanguageMenuItem />

        {!user && (
          <>
            <MenuItem
              className="px-4 py-2"
              sx={{ borderTop: `1px solid ${colors.secondary.gray94}` }}
              onClick={createNavHandler("/search")}
            >
              <Box className="text-18-regular" color={colors.secondary.gray20}>
                {tLayout("customer.marketplace")}
              </Box>
            </MenuItem>

            <MenuItem
              className="px-4 py-2"
              sx={{ borderTop: `1px solid ${colors.secondary.gray94}` }}
              onClick={createNavHandler(pathname.includes("/account/sign-in") ? "/account/sign-up" : "/account/sign-in")}
            >
              <Box className="text-18-medium" color={dt.blue}>
                {pathname.includes("/account/sign-in")
                  ? tAccount("registerButton")
                  : tAccount("loginButton")}
              </Box>
            </MenuItem>
          </>
        )}

        {user && (
          <>
            <MenuItem
              className="px-4 py-2"
              sx={{ borderTop: `1px solid ${colors.secondary.gray94}` }}
              onClick={createNavHandler("/machinery")}
            >
              <Box className="text-18-regular" color={colors.secondary.gray20}>
                {tLayout("header.myMachinery")}
              </Box>
            </MenuItem>

            <MenuItem
              className="px-4 py-2"
              sx={{ borderTop: `1px solid ${colors.secondary.gray94}` }}
              onClick={createNavHandler("/supplier")}
            >
              <Box className="text-18-regular" color={colors.secondary.gray20}>
                {tLayout("header.warehouseCenter")}
              </Box>
            </MenuItem>

            <MenuItem
              className="px-4 py-2"
              sx={{ borderTop: `1px solid ${colors.secondary.gray94}` }}
              onClick={createNavHandler("/search")}
            >
              <Box className="text-18-regular" color={colors.secondary.gray20}>
                {tLayout("customer.marketplace")}
              </Box>
            </MenuItem>

            <MenuItem
              className="px-4 py-2"
              sx={{ borderTop: `1px solid ${colors.secondary.gray94}` }}
              onClick={createNavHandler("/companies")}
            >
              <Box className="text-18-regular" color={colors.secondary.gray20}>
                {tLayout("header.customerList")}
              </Box>
            </MenuItem>

            {/* TAJMAC-PILOT-FE4: carry the origin so Settings' X returns here. */}
            <MenuItem
              className="px-4 py-2"
              sx={{ borderTop: `1px solid ${colors.secondary.gray94}` }}
              onClick={createNavHandler("/settings", { from: pathname })}
            >
              <Box className="text-18-regular" color={colors.secondary.gray20}>
                {tLayout("header.settings")}
              </Box>
            </MenuItem>
          </>
        )}
      </Box>
    </>
  );
};

export default AccountMobileMenu;


